<div
  class="language-switcher dropdown"
  (clickOutside)="closeDropdown()"
>
  <!-- Current Language Button -->
  <button
    type="button"
    class="btn btn-link p-0 lang-btn"
    (click)="toggleDropdown()"
  >
    {{ language() | uppercase }}
    <ng-icon name="bootstrapChevronDown" class="ms-1" [class.rotate]="isDropdownOpen" size="16" />
  </button>

  <!-- Dropdown Menu -->
  <div class="dropdown-menu" [class.show]="isDropdownOpen">
    @for (lang of languages; track lang) {
      <button
        type="button"
        class="dropdown-item"
        [class.active]="language() === lang"
        (click)="changeLanguage(lang)"
      >
        {{ lang | uppercase }}
      </button>
    }
  </div>
</div>
